import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const locale = i18n;
locale
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: {
          signature : "Signatures",
          createInstruction: "Add Instructions",
          name: "Name",
          home: "Scan Signature",
          documents : "Documents",
          settings: "Settings",
          currentLang: "English",
          ar: "Arabic",
          en: "English",
          footer: "All Rights Reserved by",
          consumer: "Consumer",
          sme: "SME",
          downloadTemplate: "Download Template",
          userSelect: "Select User Type",
          langSelect: "Select Template Language",
          headerScanPage: "Scan Photos",
          warningScannerApp: {
            section1: " Please make sure that the scanner app is working.",
            section2: " Or click here to open it.",
          },
          buttons: {
            next: "Next",
            finish: "Finish",
          },
          form: {
            nameAR: "Name in Arabic",
            nameEN: "Name in English",
            ssn: "Social Security Number",
            branch: "Branch",
            available: "Available From",
            category: "Category",
            job: "Job",
          },
          createForm: {
            name: "Name",
            email: "Email",
            password: "Password",
            userName: "User Name",
            bank: "Choose Bank",
            group: "Choose Group",
          },
          scanPhoto: `Scan Photo:`,
          CreateUser: "Create Users ",
          success: "Submitted Successfully",
          createBankUser: "Create Bank Users",
          sigSearch: "Signature Search",
          checkCat: "Check Category",
          unverified: "Unverified Users",
          jobs: "Jobs",

          jobsTable: {
            arabic: "Arabic",
            english: "English",
            msg: " Are you sure you want to verify this job? ",
          },
          requestType : "Request Type",
          searchTable: {
            englishName: "Name in English",
            arabicName: "Name in Arabic",
            bank: "Bank",
            branch: "Branch",
            job: "Job",
            category: "Category",
            sigLabel: "Signature Data",
            viewSig: "View Signature",
            privileges: "Privileges",
            checkInstruction: "Check Bank Instructions",
          },
          createJobs: "Create Jobs",
          editJobs : "Edit Jobs",
          unverifiedTable: {
            name: "Name",
            email: "Email",
            verify: "Activate Account",
            msg: " Are u sure u want to verify this operation? ",
            confirm: "Confirm",
            reject: "Reject",
            reason: "Reason of rejection (optional)",
            actions: "Actions",
            rejectionHead:"Are you sure you want to reject it ,Please drop you rejection note.",
            submitReject:"Submit and Reject",
            cancel:"Cancel",
            delete : "Delete"
          },
          bank: {
            bank: "Add Bank",
            entityID: "Entity ID",
          },
          branch: {
            branch: "Add Branch",
            code: "Branch Code",
            bank: "Bank",
            main: "Main Branch",
          },
          category: {
            categories: "Add Category",
            titleAR: "Title in Arabic",
            titleEN: "Title in English",
            title: "Title",
            privsAR: "Privileges in Arabic",
            privsEN: "Privileges in English",
            privs: "Privileges",
            check: "Check Categories",
          },
          scanCheck: {
            scanCheck: "Check Signatures",
            signee: "Signee Name",
            bank: "Bank",
            category: "Category",
            branch: "Branch",
            job: "Job",
          },
          login: {
            login: "Login",
            email: "Email",
            password: "Passowrd",
            emailError: "Please enter your email!",
            passwordError: "Please enter your password!",
          },
          instructions: {
            check: "Check Instructions",
            textEN: "Instructions in English",
            textAR: "Instructions in Arabic",
            instructions : "Instructions",
            editInstruction : "Edit Instructions"
          },
          settings: "Settings",
          logout: "Logout",
          accSettings: "Account Settings",
          noData: "No Data Found.",
          errors: {
            required: "This field is required.",
            scanner: "Scanner application is not working."
          },
          reports : {
            reports : "Reports",
            display : "Display",
            download : "Download",
            date : "Date",
            from : "From",
            to : "To",
            signature : "Signature Reports",
            checkedSignatures : "Checked Signatures",
            pendingSignatures : "Pending Signatures",
            userActivity : "User Activity",
            search : "Search Reports",
            category : "Categories",
            selectCategory : "Select Categories"

          },
          createCategory : "Create Category",
          createDocument:"Create Document",
          editDocument : "Edit Document",
          documentForm:{
            enName:"English Name",
            arName:"Arabic Name",
            categories:"Choose Categories"
          },
          checkDocuments:"Check Documents",
          verify:"Verify",
          edit : "Edit"


        },
       
      },
      ar: {
        translation: {
          signature : "التوقيعات",
          createInstruction: "إضافة التعليمات",
          name: "الاسم",
          home: "مسح الامضاء",
          documents : "المستندات",
          settings: "الاعدادات",
          currentLang: "العربية",
          ar: "العربية",
          en: "الانجليزية",
          footer: "جميع الحقوق محفوظة بموسطة",
          consumer: "مستهلك",
          sme: "SME",
          downloadTemplate: "تحميل النموذج",
          userSelect: "اختر نوع المستخدم",
          langSelect: "اختر لغة النموذح",
          headerScanPage: "مسح الصور",
          warningScannerApp: {
            section1: " الرجاء التأكد من أن برنامج المسح يعمل في الخلفية. ",
            section2: " أو قم بتشغيله من هنا.",
          },
          buttons: {
            next: "التالي",
            finish: "إنهاء",
          },
          form: {
            nameAR: "الاسم بالعربية",
            nameEN: "الاسم بالانجليزية",
            ssn: "رقم البطاقة",
            branch: "الفرع",
            category: "الفئة",
            job: "الوظيفة",
            available: "متاح بداية من",
          },
          scanPhoto: "مسح الصورة",
          CreateUser: "إنشاء  مستخدم",
          createForm: {
            name: "الاسم",
            email: "البريد الالكتروني",
            password: "كلمه المرور",
            userName: "اسم المستخدم",
            bank: "إختر بنك",
            group: "اختر الجروب",
          },
          success: "تم التسجيل بنجاح",
          createBankUser: "انشاء مستخدمين بنك",
          sigSearch: "البحث عن توقيع",
          checkCat: "تأكيد الفئة",
          jobs: "الأعمال",

          jobsTable: {
            arabic: "عربي",
            english: "إنجليزي",
            msg: "هل تريد تفعيل هذه المهمة",
          },
          requestType : "نوع العملية",
          searchTable: {
            viewSig: "عرض التوقيع",
            englishName: "الإسم باللغة الإنجليزية",
            arabicName: "الإسم باللغة العربية",
            bank: "البنك",
            branch: "الفرع",
            job: "الوظيفة",
            category: "الفئة",
            sigLabel: "بيانات التوقيع",
            privileges: "صلاحيات",
            checkInstruction: "عرض تعليمات البنك",
          },
          createJobs: "إنشاء مهام",
          editJobs : "تعديل المهام",
          unverified: "تحقق من المستخدمين",
          unverifiedTable: {
            name: "الاسم",
            email: "البريد الالكتروني",
            verify: "تفعيل الحساب",
            msg: "هل تريد تفعيل حساب هذه العمليه ",
            confirm: "تأكيد",
            reject: "رفض",
            reason: "سبب الرفض (اختياري)",
            actions: "الاجراءات",
            rejectionHead:"هل انت متأكد انك تريض الرفض , قم بوضع سبب الرفض",
            submitReject:"تسجيل الرفض",
            cancel:"إالغاء",
            delete : "مسح"

          },
          bank: {
            bank: "اضافة بنك",
            entityID: "كود الوحدة",
          },
          branch: {
            branch: "اضافة فرع",
            code: "كود الفرع",
            bank: "بنك",
            main: "فرع رئيسي",
          },
          category: {
            categories: "اضافة فئة",
            titleAR: "العنوان بالعربية",
            titleEN: "العنوان بالإنجليزية",
            title: "العنوان",
            privsAR: "الامتيازات بالعربية",
            privsEN: "الامتيازات بالإنجليزية",
            privs: "الامتيازات",
            check: "التحقق من الفئات",
          },
          scanCheck: {
            scanCheck: "التحقق من الامضاءات",
            signee: "اسم الموقع",
            bank: "البنك",
            category: "الفئة",
            branch: "الفرع",
            job: "الوظيفة",
          },
          login: {
            login: "تسجيل الدخول",
            email: "البريد الالكتروني",
            password: "كلمه المرور",
            emailError: "قم بإدخال البريد الالكتروني!",
            passwordError: "قم بإدخال كلمه المرور!",
          },
          instructions: {
            check: "التحقق من التعليمات",
            textEN: "التعليمات بالانجليزية",
            textAR: "التعليمات بالعربية",
            instructions : "التعليمات",
            editInstruction : "تعديل التعليمات"
          },
          settings: "الاعدادات",
          logout: " تسجيل الجروج",
          accSettings: " اعدادات الحساب",
          noData: "لا يوجد بيانات",
          errors: {
            required: "هذا العنصر اجباري.",
            scanner: "برنامح المسح لا يعمل ."
          },
          reports : {
            reports : "التقارير",
            display : "عرض",
            download : "تحميل",
            date : "التاريخ",
            from : "من",
            to : "إلي",
            signature : "تقارير التوقيعات",
            checkedSignatures : "تقارير التوقيعات المتحقق منها",
            pendingSignatures : "تقارير منتظرة",
            userActivity : "نشاطات المستخدم",
            search : "تقارير البحث",
            category : "الفئات",
            selectCategory : "اختر الفئات"
          },
          createCategory : "إنشاء فئة",
          createDocument:"إنشاء مستند",
          editDocument : "تعديل مستند",
          documentForm:{
            enName:"العنوان بالانجليزيه",
            arName:"العنوان بالعربيه",
            categories:"إختار فئات"
          },
          checkDocuments:"التحقق من المستندات",
          verify:"التحقق",
          edit : "تعديل"


        },
      },
     
    },
  });

export default locale;
